// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*:before,
*:after {
  box-sizing: border-box;
}
.ol-cta {
  display: flex !important;
  flex-wrap: wrap;
  flex-grow: 1;
  min-width: 150px;
  max-width: 100%;
}
/* ol-body is all greyed out text, like "from XXX /mo" */
.ol-body {
  font-family: Karla, Nunito Sans, Helvetica, Arial, sans-serif;
  color: #666666;
  margin: 0 4px 2px 0;
  font-size: 11px;
  line-height: 13px;
  text-align: left;
}
.ol-title {
  font-family: Karla, Roboto Condensed, Helvetica, Arial, sans-serif;
  font-weight: bold;
}
.ol-button {
  background: var(--buttonBackgroundColor) !important;
  border-radius: 2px;
  text-align: center;
  padding: 20px 0;
  cursor: pointer;
  display: block;
}

.ol-close-modal-icon {
  display: block;
  margin: auto;
  height: 50%;
  fill: currentColor;
}

.ol-cta-search {
  margin-bottom: 5px;
  padding: 8px;
  align-items: center;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  font-weight: normal;
}
a.ol-cta-search,
a.ol-cta-search:hover,
a.ol-cta-search:visited,
a.ol-cta-search:active,
a.ol-cta-search:focus {
  text-decoration: none;
}
.ol-msrp-container-search {
  min-width: 120px;
  padding-left: 4px;
  flex: 1 1 50%;
}
.ol-rate-container-search {
  align-items: center;
}

.ol-tooltip-link {
  display: flex;
}

.ol-info-button {
cursor: pointer;
}

.ol-month-label {
  display: block;
}

/* subtitle is the "instant - no credit impact" message */
.ol-msrp-subtitle-search {
  color: #898F99;
}
.ol-msrp-search {
  margin: 0 2px 0 0 !important;
  font-size: 26px !important;
  line-height: 30px !important;
  color: #4c4c4c !important;
}
.ol-button-container-search {
  flex: 1 1 50%;
  align-self: stretch;
}
.ol-button-search {
  display: flex;
  width: 100%;
  height: 100%;
  padding: 20px 4px;
  align-items: center;
  justify-content: center;
}

.ol-button-search-estimate-payment {
  display: flex;
  width: 100%;
  padding: 10px 0px;
  align-items: center;
  justify-content: center;
}
.has-estimate-payment,
.has-estimate-payment *,
.has-estimate-payment:before,
.has-estimate-payment:after,
.has-estimate-payment *:before,
.has-estimate-payment *:after {
    box-sizing: content-box !important;
}
.ol-button-text-search {
  font-size: 13px;
  line-height: 18px;
  color: var(--buttonTextColor);
}

/*
 * Slim CTA Variants
 */
.ol-cta-slim {
    border: 1px solid #B0B6C1;
    border-radius: 5px;
    box-shadow: none;
}

.ol-cta-slim .ol-button-search {
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 2px;
}

/*
 * No monthly payment variants
 */
.ol-no-payment .ol-msrp-subtitle-search {
    text-align: center !important;
}

/* hides payment container */
.ol-cta.ol-no-payment .ol-rate-container-search {
  display: none;
}

.ol-cta-standard.ol-no-payment .ol-button-text-search {
    font-size: 16px;
}

.ol-cta-standard.ol-no-payment .ol-msrp-subtitle-search {
    padding-top: 5px;
}

/* Sets button padding to zero for standard CTA with no payment */
.ol-cta-standard.ol-no-payment.ol-cta-search {
  padding: 0;
}

/* expand button and text to fill full width */
.ol-no-payment .ol-msrp-container-search {
  text-align: center;
  padding-top: 4px;
  padding-bottom: 4px;
  flex: 0 0 100%;
  max-width: 100%;
}
.ol-no-payment .ol-button-container-search {
  flex: 0 0 100%;
  max-width: 100%;
}

/* End monthly payment variants */

.ol-cta.ol-cta-mini {
  flex-wrap: initial;
  flex-grow: initial;
  min-width: 240px;
  display: flex !important;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  justify-content: center;
  align-items: baseline;
  padding: 6px 8px 6px 8px;
  cursor: pointer;
  margin-bottom: 0px;
  position: relative;
}

.ol-cta.ol-cta-mini.ol-button {
  font-family: Karla, Nunito Sans, Helvetica, Arial, sans-serif;
  color: var(--buttonTextColor);
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
}

.ol-cta.ol-cta-mini .ol-cta-text-msrp{
  margin-left: 0.4em;
  padding-right: 0.3em;
  color: var(--miniCtaButtonMsrpTextColor);
}

.ol-cta.ol-cta-mini .ol-cta-tooltip-button {
  margin-top: 0.1em;
}

.ol-cta.ol-cta-mini .ol-tooltip-link .ol-info-button {
  cursor: help;
}

.ol-cta.ol-cta-mini .ol-msrp-container{
  display: flex;
}

.ol-cta.ol-cta-mini .ol-msrp-container > span{
  display: block;
}

.ol-cta.ol-cta-mini.ol-no-payment .ol-msrp-container {
  display: none;
}

/* Oval Design */

.ol-cta-oval {
  display: flex !important;
  min-width: 170px;
  max-width: 100%;
  margin-top: 6px;
  justify-self: flex-start;
}

.ol-cta-oval .ol-cta-text-msrp{
  margin-left: 0.4em;
  padding-right: 0.3em;
  color: var(--miniCtaButtonMsrpTextColor);
}

.ol-button-oval {
  display: flex;
  width: 100%;
  height: 100%;
  padding: 3px 6px;
  align-items: center;
  justify-content: center;
}

.oval-button {
  background: #3E6EE2 !important;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  display: flex;
}

.ol-button-text-oval {
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: #ffffff;
}

.ol-title-oval {
  font-weight: 700 !important;
}

.ol-msrp-subtitle-oval {
  font-family: 'Open Sans';
  line-height: 22px;
  text-align: left;
  font-weight: 400 !important;
  color: #30333A;
  font-style: italic;
  font-size: 12px;
  margin: auto;
}

.ol-msrp-oval {
  margin: 0 6px 0 0 !important;
  font-size: 18px !important;
  line-height: 100% !important;
  font-weight: 400;
  color: #4c4c4c !important;
}

.ol-tooltip-link-oval {
  display: flex;
}

.ol-button-container-oval {
  width: 193px;
  height: 40px;
}

@media screen and (max-width: 1199px) {
  .ol-cta-oval {
    margin-left: 0;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .ol-body-oval {
    font-size: 13px;
  }
}

@media screen and (max-width: 575px) {
  .ol-cta-oval {
    justify-self: auto;
  }
}

/* Summary Design */

.ol-cta-summary {
  height: 36px;
  border-radius: 2px;
  align-content: center;
  margin: 0px 20px;
  padding: 6px 40px;
  border: 1px solid #4F96AC;
  cursor: pointer;
}

.ol-button-text-summary {
  font-size: 16px;
  color: #4F96AC;
  font-weight: 400;
}

@media screen and (max-width: 1408px) {
  .ol-cta-summary {
    margin: 0 0 20px 0;
    justify-content: center;
  }
}

/* Sidebar CTA Design */

.ol-cta-sidebar {
  position: fixed;
  top: 30%;
  left: 0;
  background: white;
  border-radius: 0px 8px 8px 0px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 5px 0px 0px;
  transition: height 0.3s ease-in-out;
  height: 170px; /* initial collapsed height */
  gap: 10px;
}

.ol-cta-sidebar:hover {
  height: 218px; /* expanded height to reveal button */
}

.sidebar-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.sidebar-icon {
  width: 55px;
  height: 55px;
  margin-bottom: 20px;
}

.sidebar-label {
  font-size: 20px;
  font-weight: 700;
  color: #111;
  line-height: 26px;
  width: 90px;
  height: 52px;
}

.sidebar-button {
  margin-top: 8px;
  margin-left: 5px;
  padding: 12px 15px;
  background-color: #005EB8;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

/* Reveal button on hover */
.ol-cta-sidebar:hover .sidebar-button {
  opacity: 1;
}

/* Banner Design */

.ol-cta-banner {
  display: flex !important;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 25px;
  height: 56px;
  border-radius: 5px;
  border: 2px solid;
}

.ol-banner-title {
  font-weight: 700;
  line-height: 20px;
  margin-right: 3px;
}

.ol-banner-body {
  font-weight: 400;
}

.ol-banner-text {
  display: contents;
  height: 26px;
  min-width: 150px;
  font-size: 16px;
  letter-spacing: 0%;
  font-family: Nunito Sans, Karla, Helvetica, Arial, sans-serif;
}

.ol-button-container-banner {
  gap: 5px;
  border-radius: 5px;
}

.ol-button-banner {
  display: flex;
  width: 100%;
  padding: 7px 7px;
  align-items: center;
  justify-content: center;
}

.ol-banner-button-title {
  font-weight: 700;
  line-height: 20px;
  color: #ffffff;
  width: max-content;
  font-family: Nunito Sans, Karla, Helvetica, Arial, sans-serif;
}

.ol-container-banner {
  display: flex;
  align-items: center;
}

.ol-banner-icon {
  margin-right: 10px;
}

@media screen and (max-width: 1070px) {
  .ol-banner-body {
    width: 80%;
  }
}

@media screen and (max-width: 900px) {
  .ol-banner-title {
    margin: 0px 10px 0px 0px;
  }

  .ol-banner-body {
    margin: 0px;
  }

  .ol-banner-text {
    font-size: 13px;
  }

  .ol-banner-button-title {
    font-size: 13px;
  }
}

@media screen and (max-width: 700px) {
  .ol-banner-text {
    display: unset;
    height: unset;
  }

  .ol-banner-body {
    width: 100%;
  }

  .ol-button-container-banner {
    padding: 4px 5px;
  }
}

@media screen and (max-width: 488px) {
  .ol-banner-text {
    font-size: 11px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/cta/css/common.css"],"names":[],"mappings":"AAAA;;;EAGE,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA,wDAAwD;AACxD;EACE,6DAA6D;EAC7D,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kEAAkE;EAClE,iBAAiB;AACnB;AACA;EACE,mDAAmD;EACnD,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;;;;EAKE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;AACA,eAAe;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,yDAAyD;AACzD;EACE,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;;;;IAMI,kCAAkC;AACtC;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE;AACF;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;EAEE;AACF;IACI,6BAA6B;AACjC;;AAEA,4BAA4B;AAC5B;EACE,aAAa;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,iEAAiE;AACjE;EACE,UAAU;AACZ;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iCAAiC;;AAEjC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,gBAAgB;;AAEhB;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,mBAAmB;;AAEnB;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,uBAAuB;EACzB;AACF;;AAEA,uBAAuB;;AAEvB;EACE,eAAe;EACf,QAAQ;EACR,OAAO;EACP,iBAAiB;EACjB,8BAA8B;EAC9B,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;EACnC,aAAa,EAAE,6BAA6B;EAC5C,SAAS;AACX;;AAEA;EACE,aAAa,EAAE,qCAAqC;AACtD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,oCAAoC;AACtC;;AAEA,2BAA2B;AAC3B;EACE,UAAU;AACZ;;AAEA,kBAAkB;;AAElB;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["*,\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n.ol-cta {\n  display: flex !important;\n  flex-wrap: wrap;\n  flex-grow: 1;\n  min-width: 150px;\n  max-width: 100%;\n}\n/* ol-body is all greyed out text, like \"from XXX /mo\" */\n.ol-body {\n  font-family: Karla, Nunito Sans, Helvetica, Arial, sans-serif;\n  color: #666666;\n  margin: 0 4px 2px 0;\n  font-size: 11px;\n  line-height: 13px;\n  text-align: left;\n}\n.ol-title {\n  font-family: Karla, Roboto Condensed, Helvetica, Arial, sans-serif;\n  font-weight: bold;\n}\n.ol-button {\n  background: var(--buttonBackgroundColor) !important;\n  border-radius: 2px;\n  text-align: center;\n  padding: 20px 0;\n  cursor: pointer;\n  display: block;\n}\n\n.ol-close-modal-icon {\n  display: block;\n  margin: auto;\n  height: 50%;\n  fill: currentColor;\n}\n\n.ol-cta-search {\n  margin-bottom: 5px;\n  padding: 8px;\n  align-items: center;\n  background: #ffffff;\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 3px;\n  font-weight: normal;\n}\na.ol-cta-search,\na.ol-cta-search:hover,\na.ol-cta-search:visited,\na.ol-cta-search:active,\na.ol-cta-search:focus {\n  text-decoration: none;\n}\n.ol-msrp-container-search {\n  min-width: 120px;\n  padding-left: 4px;\n  flex: 1 1 50%;\n}\n.ol-rate-container-search {\n  align-items: center;\n}\n\n.ol-tooltip-link {\n  display: flex;\n}\n\n.ol-info-button {\ncursor: pointer;\n}\n\n.ol-month-label {\n  display: block;\n}\n\n/* subtitle is the \"instant - no credit impact\" message */\n.ol-msrp-subtitle-search {\n  color: #898F99;\n}\n.ol-msrp-search {\n  margin: 0 2px 0 0 !important;\n  font-size: 26px !important;\n  line-height: 30px !important;\n  color: #4c4c4c !important;\n}\n.ol-button-container-search {\n  flex: 1 1 50%;\n  align-self: stretch;\n}\n.ol-button-search {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  padding: 20px 4px;\n  align-items: center;\n  justify-content: center;\n}\n\n.ol-button-search-estimate-payment {\n  display: flex;\n  width: 100%;\n  padding: 10px 0px;\n  align-items: center;\n  justify-content: center;\n}\n.has-estimate-payment,\n.has-estimate-payment *,\n.has-estimate-payment:before,\n.has-estimate-payment:after,\n.has-estimate-payment *:before,\n.has-estimate-payment *:after {\n    box-sizing: content-box !important;\n}\n.ol-button-text-search {\n  font-size: 13px;\n  line-height: 18px;\n  color: var(--buttonTextColor);\n}\n\n/*\n * Slim CTA Variants\n */\n.ol-cta-slim {\n    border: 1px solid #B0B6C1;\n    border-radius: 5px;\n    box-shadow: none;\n}\n\n.ol-cta-slim .ol-button-search {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    border-radius: 2px;\n}\n\n/*\n * No monthly payment variants\n */\n.ol-no-payment .ol-msrp-subtitle-search {\n    text-align: center !important;\n}\n\n/* hides payment container */\n.ol-cta.ol-no-payment .ol-rate-container-search {\n  display: none;\n}\n\n.ol-cta-standard.ol-no-payment .ol-button-text-search {\n    font-size: 16px;\n}\n\n.ol-cta-standard.ol-no-payment .ol-msrp-subtitle-search {\n    padding-top: 5px;\n}\n\n/* Sets button padding to zero for standard CTA with no payment */\n.ol-cta-standard.ol-no-payment.ol-cta-search {\n  padding: 0;\n}\n\n/* expand button and text to fill full width */\n.ol-no-payment .ol-msrp-container-search {\n  text-align: center;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n.ol-no-payment .ol-button-container-search {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n/* End monthly payment variants */\n\n.ol-cta.ol-cta-mini {\n  flex-wrap: initial;\n  flex-grow: initial;\n  min-width: 240px;\n  display: flex !important;\n  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);\n  border-radius: 4px;\n  justify-content: center;\n  align-items: baseline;\n  padding: 6px 8px 6px 8px;\n  cursor: pointer;\n  margin-bottom: 0px;\n  position: relative;\n}\n\n.ol-cta.ol-cta-mini.ol-button {\n  font-family: Karla, Nunito Sans, Helvetica, Arial, sans-serif;\n  color: var(--buttonTextColor);\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 14px;\n}\n\n.ol-cta.ol-cta-mini .ol-cta-text-msrp{\n  margin-left: 0.4em;\n  padding-right: 0.3em;\n  color: var(--miniCtaButtonMsrpTextColor);\n}\n\n.ol-cta.ol-cta-mini .ol-cta-tooltip-button {\n  margin-top: 0.1em;\n}\n\n.ol-cta.ol-cta-mini .ol-tooltip-link .ol-info-button {\n  cursor: help;\n}\n\n.ol-cta.ol-cta-mini .ol-msrp-container{\n  display: flex;\n}\n\n.ol-cta.ol-cta-mini .ol-msrp-container > span{\n  display: block;\n}\n\n.ol-cta.ol-cta-mini.ol-no-payment .ol-msrp-container {\n  display: none;\n}\n\n/* Oval Design */\n\n.ol-cta-oval {\n  display: flex !important;\n  min-width: 170px;\n  max-width: 100%;\n  margin-top: 6px;\n  justify-self: flex-start;\n}\n\n.ol-cta-oval .ol-cta-text-msrp{\n  margin-left: 0.4em;\n  padding-right: 0.3em;\n  color: var(--miniCtaButtonMsrpTextColor);\n}\n\n.ol-button-oval {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  padding: 3px 6px;\n  align-items: center;\n  justify-content: center;\n}\n\n.oval-button {\n  background: #3E6EE2 !important;\n  border-radius: 4px;\n  text-align: center;\n  cursor: pointer;\n  display: flex;\n}\n\n.ol-button-text-oval {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n  color: #ffffff;\n}\n\n.ol-title-oval {\n  font-weight: 700 !important;\n}\n\n.ol-msrp-subtitle-oval {\n  font-family: 'Open Sans';\n  line-height: 22px;\n  text-align: left;\n  font-weight: 400 !important;\n  color: #30333A;\n  font-style: italic;\n  font-size: 12px;\n  margin: auto;\n}\n\n.ol-msrp-oval {\n  margin: 0 6px 0 0 !important;\n  font-size: 18px !important;\n  line-height: 100% !important;\n  font-weight: 400;\n  color: #4c4c4c !important;\n}\n\n.ol-tooltip-link-oval {\n  display: flex;\n}\n\n.ol-button-container-oval {\n  width: 193px;\n  height: 40px;\n}\n\n@media screen and (max-width: 1199px) {\n  .ol-cta-oval {\n    margin-left: 0;\n    margin-bottom: 10px;\n    margin-top: 10px;\n  }\n\n  .ol-body-oval {\n    font-size: 13px;\n  }\n}\n\n@media screen and (max-width: 575px) {\n  .ol-cta-oval {\n    justify-self: auto;\n  }\n}\n\n/* Summary Design */\n\n.ol-cta-summary {\n  height: 36px;\n  border-radius: 2px;\n  align-content: center;\n  margin: 0px 20px;\n  padding: 6px 40px;\n  border: 1px solid #4F96AC;\n  cursor: pointer;\n}\n\n.ol-button-text-summary {\n  font-size: 16px;\n  color: #4F96AC;\n  font-weight: 400;\n}\n\n@media screen and (max-width: 1408px) {\n  .ol-cta-summary {\n    margin: 0 0 20px 0;\n    justify-content: center;\n  }\n}\n\n/* Sidebar CTA Design */\n\n.ol-cta-sidebar {\n  position: fixed;\n  top: 30%;\n  left: 0;\n  background: white;\n  border-radius: 0px 8px 8px 0px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 5px 0px 0px;\n  transition: height 0.3s ease-in-out;\n  height: 170px; /* initial collapsed height */\n  gap: 10px;\n}\n\n.ol-cta-sidebar:hover {\n  height: 218px; /* expanded height to reveal button */\n}\n\n.sidebar-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.sidebar-icon {\n  width: 55px;\n  height: 55px;\n  margin-bottom: 20px;\n}\n\n.sidebar-label {\n  font-size: 20px;\n  font-weight: 700;\n  color: #111;\n  line-height: 26px;\n  width: 90px;\n  height: 52px;\n}\n\n.sidebar-button {\n  margin-top: 8px;\n  margin-left: 5px;\n  padding: 12px 15px;\n  background-color: #005EB8;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n}\n\n/* Reveal button on hover */\n.ol-cta-sidebar:hover .sidebar-button {\n  opacity: 1;\n}\n\n/* Banner Design */\n\n.ol-cta-banner {\n  display: flex !important;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 25px;\n  height: 56px;\n  border-radius: 5px;\n  border: 2px solid;\n}\n\n.ol-banner-title {\n  font-weight: 700;\n  line-height: 20px;\n  margin-right: 3px;\n}\n\n.ol-banner-body {\n  font-weight: 400;\n}\n\n.ol-banner-text {\n  display: contents;\n  height: 26px;\n  min-width: 150px;\n  font-size: 16px;\n  letter-spacing: 0%;\n  font-family: Nunito Sans, Karla, Helvetica, Arial, sans-serif;\n}\n\n.ol-button-container-banner {\n  gap: 5px;\n  border-radius: 5px;\n}\n\n.ol-button-banner {\n  display: flex;\n  width: 100%;\n  padding: 7px 7px;\n  align-items: center;\n  justify-content: center;\n}\n\n.ol-banner-button-title {\n  font-weight: 700;\n  line-height: 20px;\n  color: #ffffff;\n  width: max-content;\n  font-family: Nunito Sans, Karla, Helvetica, Arial, sans-serif;\n}\n\n.ol-container-banner {\n  display: flex;\n  align-items: center;\n}\n\n.ol-banner-icon {\n  margin-right: 10px;\n}\n\n@media screen and (max-width: 1070px) {\n  .ol-banner-body {\n    width: 80%;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .ol-banner-title {\n    margin: 0px 10px 0px 0px;\n  }\n\n  .ol-banner-body {\n    margin: 0px;\n  }\n\n  .ol-banner-text {\n    font-size: 13px;\n  }\n\n  .ol-banner-button-title {\n    font-size: 13px;\n  }\n}\n\n@media screen and (max-width: 700px) {\n  .ol-banner-text {\n    display: unset;\n    height: unset;\n  }\n\n  .ol-banner-body {\n    width: 100%;\n  }\n\n  .ol-button-container-banner {\n    padding: 4px 5px;\n  }\n}\n\n@media screen and (max-width: 488px) {\n  .ol-banner-text {\n    font-size: 11px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
